import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { getRespiratorySelector } from '../selectors'
import { getServiceIdSelector } from '../../../user/selectors'
import { getPcrIdSelector } from '../../../home/selectors'
import { IPcr } from '../../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { IRespiratoryState } from '../store/respiratory.types'
import { RespiratoryConstant } from '../store/respiratory.constant'
import { respiratoryStatePrRespAssess, respiratoryStatePrNabc } from '../store/respiratory.reducers'
import { getSelectedDataFromObject } from '../../../../utilities/data.util'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* saveRespiratory() {
  const respData: IRespiratoryState = yield select(getRespiratorySelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (!pcrID) {
    return
  }
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)

    const prNabcKeys: any = Object.keys(respiratoryStatePrNabc)
    const prNabcData = getSelectedDataFromObject(respData, prNabcKeys)
    const prRespAssessKeys: any = Object.keys(respiratoryStatePrRespAssess)
    const prRespAssessData: any = getSelectedDataFromObject(respData, prRespAssessKeys)

    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      prNabc: {
        ...pcrDoc.prNabc,
        ...prNabcData,
      },
      prRespAssess: prRespAssessData.respExam,
    }
    try {
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      yield put(throwPcrException(`saveRespiratory() error: ${e}`))
    }
  }
}

export function* saveRespiratorySaga() {
  yield takeLatest([RespiratoryConstant.SAVE_RESPIRATORY], performWithMutexHOG, saveRespiratory)
}
